<nav
    class="sidenav"
    data-spy="affix"
    data-offset-top="197"
    [ngClass]="showMenu ? 'open-menu' : 'close-menu'"
>
    <ul class="main-menu p-0 m-0 menu">
        <li *ngFor="let link of listTeste" (click)="show = (link.label === show)? null : link.label">
            <a
                href="javascript:;"
                [class.dropdown-btn]="isMenuOrSubmenu(link, show)"
                [class.dropup-btn]="!isMenuOrSubmenu(link, show)"
                [hidden]="link.children === undefined"
            >
                <i class="{{ link.icon }}"></i>
                <span>{{ link.label }}</span>
            </a>
            <a
                [routerLink]="link.path"
                [class.dropdown-btn]="link.children?.length > 0"
                [hidden]="link.children != undefined">
                <i class="{{ link.icon }}"></i>
                <span>{{ link.label }}</span>
            </a>
            <ul class="items dropdown-container" *ngIf="isMenuOrSubmenu(link, show)">
                <li routerLinkActive="active" *ngFor="let sublink of link.children" (click)="show = sublink.label">
                    <a routerLinkActive="active" [routerLink]="sublink.path ">
                        <span>{{ sublink.label }}</span>
                    </a>
                </li>
            </ul>
        </li>
    </ul>
</nav>
